module.exports = __webpack_public_path__ + "img/USA-Best-2010 - 2039.a11e2c89.png";